// src/pages/ValorRosterPage.jsx
import { Link } from "react-router-dom";
import { FaTiktok, FaTwitch, FaYoutube, FaTwitter, FaInstagram } from "react-icons/fa";
import playersData from "../data/playersData";

import PetersonImg from "../assets/players/peterson.jpg";
import RvssianImg from "../assets/players/Rvssian.jpg";
import LiquidImg from "../assets/players/Liquid.jpg";
import SlayImg from "../assets/players/Slay.jpg";
import ChrisImg from "../assets/players/ChrisWz.jpg";
import GxldenImg from "../assets/players/Gxlden.jpg";
import JrwydImg from "../assets/players/Jrwyd.jpg";
import PotatoImg from "../assets/players/Chips.jpg";
import ShifuImg from "../assets/players/Shifu.jpg";
import SkrmxxImg from "../assets/players/Skrmxx.jpg";
import AnnImg from "../assets/players/Ann.jpeg";
import SpltzImg from "../assets/players/Spltz.jpeg";
import DuckyImg from "../assets/players/Ducky.jpg";
import ValorHero from "../assets/divisions/valor.jpeg";

const imageMap = {
  XoPeterson: PetersonImg,
  DemonRvssian: RvssianImg,
  liquid: LiquidImg,
  Slay: SlayImg,
  ChrisWZ: ChrisImg,
  yyGxlden: GxldenImg,
  Jrwyd: JrwydImg,
  Potaatochips: PotatoImg,
  Shifu: ShifuImg,
  "The Jamaican Shifu": ShifuImg,
  Skrmxx: SkrmxxImg,
  Ann: AnnImg,
  SpltzFps: SpltzImg,
  Ducky: DuckyImg,
};

function ValorRosterPage() {
  const valorPlayers = playersData.filter(
    p => p.division === "CDL Coach" || p.division === "CDL Substitute"
  );

  return (
    <main className="bg-black min-h-screen">
      <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center">
        <div className="absolute inset-0">
          <img src={ValorHero} alt="Valor Team" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/40"></div>
        </div>
        <div className="relative z-10 text-center px-6">
          <span className="text-red-500 text-sm font-semibold uppercase tracking-wider mb-2 block">
            Competitive Support
          </span>
          <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tight text-white mb-4">
            <span className="text-red-600">Valor</span> Roster
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Coaches and substitute players powering the Prime Valor competitive squad
          </p>
          <Link
            to="/roster"
            className="inline-flex items-center gap-2 mt-6 text-gray-400 hover:text-white transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Teams
          </Link>
        </div>
      </section>

      <section className="py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl font-bold text-white mb-8 uppercase border-l-4 border-red-600 pl-4">
            Valor
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {valorPlayers.map((player) => (
              <Link
                to={`/roster/${player.id}`}
                key={player.id}
                className="group flex items-center gap-4 bg-gray-900 rounded-lg p-4 border border-gray-800 hover:border-red-600/50 hover:bg-gray-800/50 transition-all duration-300"
              >
                <div className="flex-shrink-0 w-16 h-16 rounded-full overflow-hidden bg-gray-800 border-2 border-gray-700 group-hover:border-red-600/50 transition-colors">
                  <img
                    src={imageMap[player.name]}
                    alt={player.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <span className="text-xs font-semibold uppercase tracking-wider text-red-500 block mb-1">
                    {player.division}
                  </span>
                  <h3 className="text-lg font-bold text-white group-hover:text-red-500 transition-colors truncate">
                    {player.name}
                  </h3>
                  <p className="text-sm text-gray-400 truncate">{player.country}</p>
                  <div className="flex gap-2 mt-2">
                    {player.socials?.tiktok && <a href={player.socials.tiktok} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="text-gray-500 hover:text-red-500 transition-colors"><FaTiktok size={14} /></a>}
                    {player.socials?.twitch && <a href={player.socials.twitch} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="text-gray-500 hover:text-purple-500 transition-colors"><FaTwitch size={14} /></a>}
                    {player.socials?.youtube && <a href={player.socials.youtube} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="text-gray-500 hover:text-red-600 transition-colors"><FaYoutube size={14} /></a>}
                    {player.socials?.twitter && <a href={player.socials.twitter} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="text-gray-500 hover:text-blue-400 transition-colors"><FaTwitter size={14} /></a>}
                    {player.socials?.instagram && <a href={player.socials.instagram} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="text-gray-500 hover:text-pink-500 transition-colors"><FaInstagram size={14} /></a>}
                  </div>
                </div>
                <div className="flex-shrink-0 text-gray-600 group-hover:text-red-500 transition-colors">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

export default ValorRosterPage;
